<ng-container *transloco="let t">
<div class="modal-header">
  <h5 class="modal-title d-flex align-items-center">{{ t('portal.addDocuments.title') }}</h5>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()" [attr.aria-label]="t('common.close')"></button>
</div>

<div class="modal-body">
  <form>
    @if (borrowerChoices.length > 1) {
    <div class="row mb-3">
      <div class="col-md-6 col-12 fv-row">
        <label class="form-label mb-2">{{ t('portal.addDocuments.selectBorrower') }}</label>
        <div class="form-group ms-auto">
          <select [(ngModel)]="selectedBorrowerId" class="form-select" name="selectedBorrower">
            @for (borrower of borrowerChoices; track borrower.borrowerId) {
              <option [ngValue]="borrower.borrowerId">
                {{ borrower.borrowerName }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
    }

    <div class="row mb-3">
      <div class="col-md-12 fv-row">
        <label class="form-label" for="notes">{{ t('portal.addDocuments.notes') }}</label>
        <textarea class="form-control" rows="2" [(ngModel)]="notes" name="notes" [placeholder]="t('portal.addDocuments.notesPlaceholder')"></textarea>
      </div>
    </div>

    <hr />

    <file-upload (uploadClicked)="onUploadClicked($event)" [isUploading]="isUploading"></file-upload>
  </form>
</div>
</ng-container>
